import {Component, OnDestroy, OnInit, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {SafeHtml} from '@angular/platform-browser';

export interface ConfirmationDialogData {
  title: string;
  content?: string;
  name?: string;
  cancelLabel?: string;
  confirmLabel?: string;
  buttonType?: string;
  hideConfirmButton?: boolean;
}

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: [],
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit, OnDestroy {
    acceptClose: Subject<boolean> = new Subject();
    cancelClose: Subject<boolean> = new Subject();
    htmlContent: SafeHtml;

    constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData) {}

    ngOnInit() { }

    ngOnDestroy() { }

    confirmAction(boolean: boolean) {
        this.acceptClose.next(boolean);
        this.dialogRef.close(true);
    }
    cancelAction(boolean: boolean) {
        this.cancelClose.next(boolean);
        this.dialogRef.close(false);
    }
}